<template>
    <div class="grid grid-cols-1 lg:grid-cols-2 overflow-hidden hero" :class="{rtl: isRtl}" data-testid="club-home-hero"
        :style="props.bgImgFull? fullBgStyle: null">
        <div class="col-span-1 lg:p-10 text-left lg:text-left flex items-center hero-text clubs-bg-color"
            :style="props.bgImgLeft ? leftColumnBgStyle: null">
            <section class="px-10">
                <span class="block text-4xl font-bold mb-5">{{ title }}</span>
                <p class="mt-0 mb-4 hero-text line-height-3 ">{{ description }}</p>
                <RouterLink :to="buttonLink1" data-testid="hero-button" v-if="buttonLink1">
                    <Button :icon="buttonIcon1" :label="buttonText1" type="button"
                        class="p-button-warn mr-3 mb-2"></Button>
                </RouterLink>
                <RouterLink :to="buttonLink2" data-testid="hero-button" v-if="buttonLink2">
                    <Button :icon="buttonIcon2" :label="buttonText2" type="button" class="p-button-primary mb-2 bg-white"
                        outlined></Button>
                </RouterLink>
            </section>
        </div>
        <div class="col-span-1 hidden lg:flex justify-end bg-cover bg-no-repeat bg-right"
            :style="props.bgImgRight ? rightColumnBgStyle: null"
            :role="props.bgImgRight ? 'img' : null"
            :aria-label="props.bgImgRight ? props.bgImgRightAlt : null">
        </div>
    </div>
</template>
<script setup>
import { ref } from 'vue';
import { RouterLink } from 'vue-router';
import Button from 'primevue/button';
const props = defineProps({
    title: {
        type: String,
        required: true
    },
    description: {
        type: String,
        required: true
    },
    buttonText1: {
        type: String,
        required: true
    },
    buttonText2: {
        type: String,
        required: false
    },
    buttonLink1: {
        type: String,
        required: true
    },
    buttonLink2: {
        type: String,
        required: false
    },
    buttonIcon1: {
        type: String,
        required: false
    },
    buttonIcon2: {
        type: String,
        required: false
    },
    bgImgFull: {
        type: String,
        required: false
    },
    bgImgLeft: {
        type: String,
        required: false
    },
    bgImgRight: {
        type: String,
        required: false
    },
    bgImgRightAlt: {
        type: String,
        required: false
    },

});

const fullBgStyle = ref({ 'background-image': 'url(' + props.bgImgFull + ')',  })
const leftColumnBgStyle = ref({ 'background-image': 'url(' + props.bgImgLeft + ')',  })
const rightColumnBgStyle = ref({ 'background-image': 'url(' + props.bgImgRight + ')',  })


const isRtl = ref(true);

</script>
<style scoped>
.hero {
    min-height: 34rem;
}

.hero-text {
    color: var(--p-wusa-navy-500);
}

/* todo: configurable bg color in mobile/tablet view */
@media only screen and (max-width: 1024px) {
    .clubs-bg-color {
        background: linear-gradient(147deg, #A7EBDD 8.65%, #57A5F4 97.61%);
    }
}


</style>